import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Button
} from 'semantic-ui-react'

const ModReMedicationUX = (props: any) => {
    return(
      <div>
        <div
          id="ModReMedicationUX-div-1"
          style={{position: "relative"}}>
          
          <div
            id="ModReMedicationUX-div-2"
            style={{"width":"100%","height":"100%","display":"grid","position":"relative","gridTemplateRows":"repeat(45, 1fr)","gridTemplateColumns":"repeat(50, 1fr)"}}>
            <div
              id="ModReMedicationUX-div-3"
              style={{ gridRow: "2/6", gridColumn: "2/50"}}>
              <div
                id="ModReMedicationUX-div-8"
                style={{fontWeight: "bold", fontSize: "20px", paddingBottom: "10px"}}>
                {props.languageUX === "en" ? "Order medication based on the patient's previous medical history" : "สั่งยาจากประวัติเดิมของผู้ป่วย"}
              </div>
              <hr
                id="ModReMedicationUX-hr-9">
              </hr>
            </div>
            <div
              id="ModReMedicationUX-div-4"
              style={{ gridRow: "7/10", gridColumn: "2/50",display:"flex", alignItems: "center"}}>
              <div
                id="ModReMedicationUX-div-10"
                style={{width: "25%",  padding: "0px 5px"}}>
                {props.doctorSearchBox}
              </div>
              <div
                id="ModReMedicationUX-div-12"
                style={{width: "25%",padding: "0px 5px"}}>
                {props.divisionSearchBox}
              </div>
              <Button
                color="blue"
                id="ModReMedicationUX-Button-17"
                onClick={props.onSearchReMED}>
                {props.languageUX === "en" ? "Search" : "ค้นหา"}
              </Button>
            </div>
            <div
              id="ModReMedicationUX-div-5"
              style={{ gridRow: "11/39", gridColumn: "2/50"}}>
              <div
                id="ModReMedicationUX-div-16"
                style={{fontWeight: "bold", fontSize: "20px", paddingBottom: "10px"}}>
                {props.languageUX === "en" ? "Past Medication" : "การใช้ยาในอดีต"}
              </div>
              <Table
                data={props.remedData}
                getTrProps={props.remedTrProps}
                headers=",ชื่อยา,วิธีใช้,จำนวน,หน่วย"
                id="ModReMedicationUX-Table-13"
                keys="selected,name,prescription_label,quantity,unit"
                minRows="8"
                showPagination={false}
                widths="50,,,100,100">
              </Table>
            </div>
            <div
              id="ModReMedicationUX-div-6"
              style={{ gridRow: "40/44", gridColumn: "2/12" }}>
              <Button
                color="blue"
                id="ModReMedicationUX-Button-14"
                onClick={props.onClickAddToOrder}>
                {props.languageUX === "en" ? "ADD TO ORDER" : "เพิ่มลงในคำสั่งซื้อ"}
              </Button>
            </div>
            <div
              id="ModReMedicationUX-div-7"
              style={{ gridRow: "40/44", gridColumn: "42/50", textAlign:"right"}}>
              <Button
                color="grey"
                id="ModReMedicationUX-Button-15"
                onClick={props.onClickCancel}>
                {props.languageUX === "en" ? "CANCEL" : "ยกเลิก"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
}


export default ModReMedicationUX

export const screenPropsDefault = {}

/* Date Time : Wed Oct 01 2025 12:13:05 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModReMedicationUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "label": "divgrid",
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModReMedicationUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{\"width\":\"100%\",\"height\":\"100%\",\"display\":\"grid\",\"position\":\"relative\",\"gridTemplateRows\":\"repeat(45, 1fr)\",\"gridTemplateColumns\":\"repeat(50, 1fr)\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "ModReMedicationUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"2/6\", gridColumn: \"2/50\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "ModReMedicationUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"7/10\", gridColumn: \"2/50\",display:\"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "ModReMedicationUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"11/39\", gridColumn: \"2/50\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "ModReMedicationUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"40/44\", gridColumn: \"2/12\" }"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "ModReMedicationUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"40/44\", gridColumn: \"42/50\", textAlign:\"right\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "สั่งยาจากประวัติเดิมของผู้ป่วย",
          "valueEN": "Order medication based on the patient's previous medical history"
        },
        "id": {
          "type": "value",
          "value": "ModReMedicationUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"20px\", paddingBottom: \"10px\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "hr",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "ModReMedicationUX-hr-9"
        }
      },
      "seq": 9,
      "void": true
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doctorSearchBox"
        },
        "id": {
          "type": "value",
          "value": "ModReMedicationUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{width: \"25%\",  padding: \"0px 5px\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": "props.divisionSearchBox"
        },
        "id": {
          "type": "value",
          "value": "ModReMedicationUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{width: \"25%\",padding: \"0px 5px\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 13,
      "name": "Table",
      "parent": 5,
      "props": {
        "data": {
          "type": "code",
          "value": "props.remedData"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.remedTrProps"
        },
        "headers": {
          "type": "value",
          "value": ",ชื่อยา,วิธีใช้,จำนวน,หน่วย"
        },
        "id": {
          "type": "value",
          "value": "ModReMedicationUX-Table-13"
        },
        "keys": {
          "type": "value",
          "value": "selected,name,prescription_label,quantity,unit"
        },
        "minRows": {
          "type": "value",
          "value": "8"
        },
        "pageSize": {
          "type": "value",
          "value": ""
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "subRowsKey": {
          "type": "value",
          "value": ""
        },
        "widths": {
          "type": "value",
          "value": "50,,,100,100"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Button",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มลงในคำสั่งซื้อ",
          "valueEN": "ADD TO ORDER"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "ModReMedicationUX-Button-14"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickAddToOrder"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Button",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก",
          "valueEN": "CANCEL"
        },
        "color": {
          "type": "value",
          "value": "grey"
        },
        "id": {
          "type": "value",
          "value": "ModReMedicationUX-Button-15"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickCancel"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "การใช้ยาในอดีต",
          "valueEN": "Past Medication"
        },
        "id": {
          "type": "value",
          "value": "ModReMedicationUX-div-16"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"20px\", paddingBottom: \"10px\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Button",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "ModReMedicationUX-Button-17"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSearchReMED"
        }
      },
      "seq": 17,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 70,
  "isMounted": false,
  "memo": false,
  "name": "ModReMedicationUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 65
}

*********************************************************************************** */
